module.exports = __webpack_public_path__ + "static/img/certificate04.a406fda7.jpeg";